import React from 'react';
import classnames from 'classnames';
var MembershipCardInfo = function(props) {
    var firstHeader = props.firstHeader, secondHeader = props.secondHeader, supplementalText = props.supplementalText, primaryText = props.primaryText, secondText = props.secondText, noMembership = props.noMembership;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('MembershipCardInfo', {
            noMembership: noMembership
        })
    }, firstHeader && /*#__PURE__*/ React.createElement("h5", {
        className: "firstHeader"
    }, firstHeader), /*#__PURE__*/ React.createElement("div", {
        className: "secondContainer"
    }, secondHeader && /*#__PURE__*/ React.createElement("h2", {
        className: "secondHeader"
    }, secondHeader), secondText && /*#__PURE__*/ React.createElement("p", {
        className: "secondText"
    }, secondText)), primaryText && /*#__PURE__*/ React.createElement("p", {
        className: "primaryText"
    }, primaryText), supplementalText && /*#__PURE__*/ React.createElement("p", {
        className: "supplementalText"
    }, "(".concat(supplementalText, ")")));
};
export default MembershipCardInfo;
